@if (items.length) {
  <nav class="breadcrumb" aria-label="breadcrumb">
    <ol class="breadcrumb-list">
      @for (item of items; track item; let last = $last) {
        <li class="breadcrumb-item">
          @if (!last && item.url && !item.disabled) {
            <a [routerLink]="item.url" class="breadcrumb-link">
              @if (item.icon) {
                <mat-icon class="breadcrumb-icon">{{ item.icon }}</mat-icon>
              }
              <span class="breadcrumb-label">{{ item.label }}</span>
            </a>
          }
          @if (last || !item.url || item.disabled) {
            <span class="breadcrumb-label breadcrumb-current">
              @if (item.icon) {
                <mat-icon class="breadcrumb-icon">{{ item.icon }}</mat-icon>
              }
              {{ item.label }}
            </span>
          }
          @if (!last) {
            <mat-icon class="breadcrumb-sep">chevron_right</mat-icon>
          }
        </li>
      }
    </ol>
    <!-- Caso manualItems e strategy necessitem, basta ajustar @Input() no selector no container. -->
  </nav>
}


